import { RcFile } from 'antd/lib/upload';
import imageCompression, { Options as CompressOptions } from 'browser-image-compression';

const MAX_SIZE_MB = 1.5;
const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024; // MAX_SIZE_MB in bytes

const COMPRESS_OPTIONS: CompressOptions = {
  maxWidthOrHeight: 1280,
  useWebWorker: true,
} as const;

export const compressFile = async (file: File | RcFile): Promise<File | undefined> => {
  try {
    // Don't invoke library at all when file is already small enough
    if (file.size <= MAX_SIZE_BYTES) {
      return file;
    }

    const compressedFile = await imageCompression(file, COMPRESS_OPTIONS);
    // Create new File with original name
    return new File([compressedFile], file.name, {
      type: compressedFile.type,
      lastModified: Date.now(),
    });
  } catch (error) {
    console.error('Compression failed for ', file.name, error);
    return undefined;
  }
};

export const compressFiles = async (filesToCompress: (File | RcFile | undefined)[]): Promise<(File | undefined)[]> => {
  return await Promise.all(
    filesToCompress.filter((file): file is File | RcFile => file !== undefined).map(file => compressFile(file)),
  );
};

export const compressFilesArrays = async (
  filesArraysToCompress: (File | RcFile | undefined)[][],
): Promise<(File | undefined)[][]> => {
  return await Promise.all(filesArraysToCompress.map(filesArray => compressFiles(filesArray)));
};
